import FancyboxUtil from '../../../src/js/shared/FancyboxV5';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const reservationPopup = {


		init: function() {
			this.initPopup();
		},

		initPopup: function() {
			FancyboxUtil.initializefancyboxPopup('.js-reservation-popup', 'popup-modern popup-modern--reservation', {
				on: {
					close: () => {
						const activeSuccessPopup = $('.fancybox__content#reservation-success-popup');

						if (activeSuccessPopup.length) {
							document.location.href = '/';
						}
					}
				}
			});
		},
	};

	reservationPopup.init();
});
